import request from "@/utils/request";
import { data } from "jquery";

// 视频
export function supportVideo(data) {
  return request({
    url: `/api/business/supportVideo/getPageList`,
    method: "post",
    data
  });
}
export function supportVideoInfo(id) {
  return request({ url: `/api/business/supportVideo/getInfo/${id}`, method: "get" });
}
//tree
export function DictionaryData() {
  return request({
    url: `/api/system/DictionaryData/803945541590348421/Selector/0?isTree=1`,
    method: "GET",
  });
}
//常见问题
export function supportQuestion(data) {
  return request({
    url: `/api/business/supportQuestion/getPageList`,
    method: "post",
    data
  });
}
export function supportQuestionInfo(id) {
  return request({ url: `/api/business/supportQuestion/getInfo/${id}`, method: "get" });
}
//常见问题tree
export function supportQuestionTree() {
  return request({
    url: `/api/system/DictionaryData/803951016163701445/Selector/0?isTree=1`,
    method: "GET",
  });
}
//产品手册
export function supportOptGuide(data) {
  return request({
    url: `/api/business/supportOptGuide/getPageList`,
    method: "post",
    data
  });
}
export function supportOptGuideInfo(id) {
  return request({ url: `/api/business/supportOptGuide/getInfo/${id}`, method: "get" });
}
//产品手册tree
export function supportOptGuideTree() {
  return request({
    url: `/api/system/DictionaryData/803951143204975301/Selector/0?isTree=1`,
    method: "GET",
  });
}
//更新日志
export function supportUpdateLog(data) {
  return request({
    url: `/api/business/supportUpdateLog/getPageList`,
    method: "post",
    data
  });
}
export function supportUpdateLogInfo(id) {
  return request({ url: `/api/business/supportUpdateLog/getInfo/${id}`, method: "get" });
}
//更新日志tree
export function supportUpdateLogTree() {
  return request({
    url: `/api/system/DictionaryData/803950928536302277/Selector/0?isTree=1`,
    method: "GET",
  });
}
//新媒体视频
export function supportNewMediaVideo(data) {
  return request({
    url: `/api/business/supportNewMediaVideo/getPageList`,
    method: "post",
    data
  });
}
export function supportNewMediaVideoInfo(id) {
  return request({ url: `/api/business/supportNewMediaVideo/getInfo/${id}`, method: "get" });
}
//新媒体视频tree
export function supportNewMediaVideoTree() {
  return request({
    url: `/api/system/DictionaryData/803958058450449093/Selector/0?isTree=1`,
    method: "GET",
  });
}
//新媒体视频tree
export function System_article(data) {
  return request({
    url: `/api/business/System_article/getList`,
    method: "post",
    data: data || {
      "currentPage": 1,
      "pageSize": 20,
    }
  });
}

// 服务支持全局搜索（分页）
export function serviceSearch(data) {
  return request({
    url: `/api/business/subscribeGuide/searchData`,
    method: "post",
    data
  });
}

// 服务支持各类型数量统计
export function serviceCount(keyword) {
  return request({
    url: `/api/business/subscribeGuide/getCountData`,
    method: "post",
    data: { keyword: keyword || "" }
  });
}

